/**
 * Default CDN URL for the wallet book.
 */
const DEFAULT_WALLET_BOOK_CDN_URL =
  'https://dynamic-static-assets.com/wallet-book/v1/stable/wallet-book.json';

/**
 * Gets the wallet book CDN URL from environment variables with fallback to default.
 *
 * Checks for environment variables in the following order:
 * 1. WALLET_BOOK_CDN_URL
 * 2. NEXT_PUBLIC_WALLET_BOOK_CDN_URL
 * 4. Default CDN URL
 *
 * @returns The wallet book CDN URL to use.
 */
export const getWalletBookCdnUrl = (): string => {
  if (typeof process !== 'undefined' && process.env) {
    const envVar =
      process.env.WALLET_BOOK_CDN_URL ||
      process.env.NEXT_PUBLIC_WALLET_BOOK_CDN_URL;

    if (envVar) {
      return envVar;
    }
  }

  return DEFAULT_WALLET_BOOK_CDN_URL;
};
